import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";
import { MdPayment } from "react-icons/md";

const PosEPaymentsHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الدفع الالكتروني للنقاط
          </Typography>
        }
        avatar={<MdPayment size={20} />}
      />
    </Card>
  );
};

export default PosEPaymentsHeader;
